import style from "./toggle.module.scss";

const ToggleSwitch = ({
  id,
  name,
  label,
  value,
  error,
  checked,
  switchRef,
  className,
  handleClick,
  handleChange,
  defaultChecked,
}) => {
  return (
    <div>
      <label
        htmlFor={id}
        className={`${style.container} ${className}`}
        style={{
          fontSize: "16px",
        }}
      >
        {label}
        <input
          id={id}
          name={name}
          value={value}
          type="checkbox"
          ref={switchRef}
          checked={checked}
          onClick={handleClick}
          onChange={handleChange}
          defaultChecked={defaultChecked}
        />
        <span className={style.toggleSwitch} style={{ borderColor: error ? "red" : "" }}></span>
      </label>
    </div>
  );
};

export default ToggleSwitch;
